"use strict";
/*
 "libqp" customised for Vereign SEAL
 Copyright (C) 2020-2021, Vereign AG
 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as
 published by the Free Software Foundation, either version 3 of the
 License, or (at your option) any later version.
 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details.
 You should have received a copy of the GNU Affero General Public License
 along with this program.  If not, see https://www.gnu.org/licenses/.
 In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland


 This program ("libqp" customised for Vereign SEAL) incorporates work covered by the following copyright and permission notice:
 "libqp"
 Copyright (c) 2014 Andris Reinman
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.
 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeQP = void 0;
/**
 * Decodes a Quoted-Printable encoded string to a Buffer object
 *
 * @param {String} str Quoted-Printable encoded string
 * @returns {Buffer} Decoded value
 */
const decodeQP = (str) => {
    str = (str || "")
        .toString()
        // remove invalid whitespace from the end of lines
        .replace(/[\t ]+$/gm, "")
        // remove soft line breaks
        .replace(/=(?:\r?\n|$)/g, "");
    let encodedBytesCount = (str.match(/=[\da-fA-F]{2}/g) || []).length, bufferLength = str.length - encodedBytesCount * 2, chr, hex, buffer = new Buffer(bufferLength), bufferPos = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        chr = str.charAt(i);
        if (chr === "=" &&
            (hex = str.substr(i + 1, 2)) &&
            /[\da-fA-F]{2}/.test(hex)) {
            buffer[bufferPos++] = parseInt(hex, 16);
            i += 2;
            continue;
        }
        buffer[bufferPos++] = chr.charCodeAt(0);
    }
    return buffer;
};
exports.decodeQP = decodeQP;
